module.exports = __webpack_public_path__ + "media/images/vertical_side_shadow_for_big_box-21110110c27cee38acce55d0fd054a86.svg";